/**
 * Actions you can make on chatbot
 * @module  {Actions} chatbotActions
 */
export const OPEN = '@@chatbot/OPEN'
export const CLOSE = '@@chatbot/CLOSE'

/**
 * Opens the chatbot
 *
 * @return {Object}           open action payload
 */
export const open = () => ({
  type: OPEN
})

/**
 * Closes the chatbot
 *
 * @return {Object}           close action payload
 */
export const close = () => ({
  type: CLOSE
})

/**
 * Toggle the chatbot
 *
 * @return {Object}           toggle action payload
 */
export const toggle = () => (dispatch, getState) => {
  const { chatbot: { open: isOpen } } = getState()
  if (!!isOpen) {
    return dispatch(close())
  } else {
    return dispatch(open())
  }
}



// WEBPACK FOOTER //
// ./state/actions/chatbotActions.js